import { clearAccessToken, clearUserInfo, setAccessToken } from '../auth/token'
import { http } from '../http'

export interface ApiResponse<T> {
  code: number
  data: T
  rows?: T
  msg: string
  total?: number
  summary?: T
}

export interface LoginParams {
  username: string
  password: string
  erpOrPos: 'erp'
}

export interface LoginResult {
  access_token: string
  expiresIn: number
  first?: 0 | 1
  userId?: number | string
}

export const authApi = {
  async login(params: LoginParams) {
    const result = await http.post<ApiResponse<LoginResult>>('/miss-auth/login', params, {
      skipAuth: true,
      unwrap: false,
    })

    if (result.code === 200) {
      setAccessToken(result.data.access_token)
    }

    return result
  },

  async logout() {
    try {
      return await http.delete<ApiResponse<unknown>>('/miss-auth/logout', {
        unwrap: false,
      })
    } finally {
      clearAccessToken()
      clearUserInfo()
    }
  },
}
